import type { GemxQlQueryResponse, GemxQlQueryVariables } from '~/core/gemxql/graphql';
import type { IReportType } from '~/modules/report-analytic/types/report';
import type { BaseHeaderResponse } from '~/api/types/graphqlClient';
import type { UseQueryOptions } from '@tanstack/react-query';

import { GemxQlDocument } from '~/core/gemxql/graphql';
import { useQuery } from '@tanstack/react-query';
import { appFetcherCustom } from '~/api/utils';

export interface CustomGemXQlResponse extends GemxQlQueryResponse {
  gemxQLQuery: IReportType;
  headers: BaseHeaderResponse;
}

export const useCustomGemXQlQuery = <TData = CustomGemXQlResponse, TError = unknown>(
  variables: GemxQlQueryVariables,
  options?: UseQueryOptions<CustomGemXQlResponse, TError, TData>,
) => {
  return useQuery<CustomGemXQlResponse, TError, TData>(
    ['GemXQlCustom', variables],
    appFetcherCustom<CustomGemXQlResponse, GemxQlQueryVariables>(GemxQlDocument, variables),
    options,
  );
};

useCustomGemXQlQuery.getKey = (variables: GemxQlQueryVariables) => ['GemXQlCustom', variables];
